module.exports = __webpack_public_path__ + "fff53b0baec084de78e12351c5d12df4.svg";